import { adminMeetingsList } from '@/services/meetings.service'

export default {
	namespaced: true,
	state: {
		meetingsList: { meta: { pagination: { total: 0 } } },
		meetingsStatus: 'init',
	},
	getters: {
		getMeetingsList: s => s.meetingsList,
		getMeetingsStatus: s => s.meetingsStatus,
	},
	mutations: {
		MEETINGS_LIST(state, value) { state.meetingsList = value },
		MEETINGS_STATUS(state, value) { state.meetingsStatus = value },
	},
	actions: {
		async fetchMeetingsList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('MEETINGS_STATUS', 'pending')
			commit('MEETINGS_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await adminMeetingsList(params)
				commit('MEETINGS_STATUS', 'init')
				commit('MEETINGS_LIST', data)
				return data
			} catch (error) {
				commit('MEETINGS_STATUS', 'init')
				throw error
			}
		},
	},
}
